export const HOME = {
  emergentLink: "home-emergent-link",
};

export const TEST_IDS = {
  // Hero
  heroRegisterCta: "hero-register-cta",
  heroHeadline: "hero-headline",
  // Ticker
  marquee: "brand-marquee",
  // Founder
  founderSection: "founder-section",
  // Form
  regForm: "registration-form",
  regNameInput: "reg-name-input",
  regEmailInput: "reg-email-input",
  regPhoneInput: "reg-phone-input",
  regBusinessInput: "reg-business-input",
  regSubmit: "reg-submit-button",
  regSuccess: "reg-success-message",
  // FAQ
  faqAccordion: "faq-accordion",
  // Chatbot
  chatFab: "chat-fab",
  chatPanel: "chat-panel",
  chatClose: "chat-close",
  chatInput: "chat-input",
  chatSend: "chat-send",
  chatMessages: "chat-messages",
};
